// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
  useGetAllServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
} from '../../store/api/serviceProviderApi';
import * as Yup from 'yup';
import { Box, Button, Container, MenuItem, Select, TextField, Typography } from '@mui/material';
import Page from '../../components/Page';
import { getServiceProviderDetails, setServiceProvider } from '../../store/state/serviceProviderSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Loading from '../../components/Loading';
import {
  useGetAllParkingSpaceLocationMutation,
  useUpdateParkingSpaceLocationMutation,
} from '../../store/api/parkingsApi';
import { setParkings } from '../../store/state/parkingSlice';
import { useGetEnumDataMutation } from '../../store/api/enumApi';
import { getSpecificEnumData, setEnumData } from '../../store/state/enumSlice';

const VendorsSchema = Yup.object().shape({
  name: Yup.string().required('Vendor Name is required'),
  contactNumber: Yup.string().required('Contact is required'),
  tierType: Yup.string().required('Tier Type is required'),
  commission: Yup.string().required('Commission is required'),
});

const ParkingsSchema = Yup.object().shape({
  name: Yup.string().required('Parking Space Name is required'),
  vendorName: Yup.string().required('Vendor Name is required'),
  tierType: Yup.string().required('Tier Type is required'),
  commission: Yup.string().required('Commission is required'),
});

export default function AddCommission() {
  const dispatch = useAppDispatch();
  const [initialValuesVendor, setInitialValuesVendor] = useState({
    name: '',
    contactNumber: '',
    tierType: '',
    commission: '',
  });
  const [initialValuesParking, setInitialValuesParking] = useState({
    name: '',
    vendorName: '',
    tierType: '',
    commission: '',
  });
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const [commissionData, setCommissionData] = useState([]);
  const [getAllServiceProviderDetail, getAllResponse] = useGetAllServiceProviderDetailMutation();
  const [updateServiceProviderDetail, updateResponse] = useUpdateServiceProviderDetailMutation();
  const [getAllParkingSpaceLocation, getAllParkingSpaceLocationResponse] = useGetAllParkingSpaceLocationMutation();
  const [updateParkingSpaceLocation, updateParkingSpaceLocationResponse] = useUpdateParkingSpaceLocationMutation();
  const serviceProviderData = useAppSelector(getServiceProviderDetails);
  const { state } = useLocation();
  const [page, setPage] = useState(0);
  const [offset, setOffset] = useState(5);
  const [orderBy, setOrderBy] = useState('asc');
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [tierType, setTierType] = useState([]);

  useEffect(() => {
    if (serviceProviderData) {
      setCommissionData(serviceProviderData);
    }
  }, [serviceProviderData]);

  // add
  useEffect(() => {
    if (updateResponse.isSuccess) {
      getAllServiceProviderDetail({
        token: token.token,
        payload: {
          page: page,
          offset: offset,
          orderBy: orderBy,
        },
      });
      toast.success('Commission updated successfully');
    }
    if (updateParkingSpaceLocationResponse.isSuccess) {
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          page: page,
          offset: offset,
          orderBy: orderBy,
        },
      });
    }
  }, [updateResponse.isSuccess, updateParkingSpaceLocationResponse.isSuccess]);

  useEffect(() => {
    getEnumData({ token: token.token });
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setTierType(enumData['TIER_TYPE']);
    }
  }, [enumData]);

  // update store
  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setServiceProvider(getAllResponse.data));
      navigate('/dashboard/commission-management?view_type=0');
    }
    if (updateParkingSpaceLocationResponse.isSuccess) {
      dispatch(setParkings(updateParkingSpaceLocationResponse.data));
      navigate('/dashboard/commission-management?view_type=1');
    }
  }, [getAllResponse.isSuccess, updateParkingSpaceLocationResponse.isSuccess]);

  // set formik initial values
  useEffect(() => {
    if (state.editData && state.isEditVendor) {
      setInitialValuesVendor({
        name: state.editData.name,
        contactNumber: state.editData.contactNumber,
        emailId: state.editData.emailId,
        password: state.editData.password ? state.editData.password : '',
        gstNo: state.editData.gstNo,
        primaryAccountNo: state.editData.primaryAccountNo,
        vatNo: state.editData.vatNo,
        tierType: state.editData.tierType,
        commission: state.editData.commission,
        status: true,
      });
    } else if (state.editData && !state.isEditVendor) {
      setInitialValuesParking({
        address: state.editData.address,
        capacity: state.editData.capacity,
        cityId: state.editData.cityId,
        cityName: state.editData.cityName,
        closeAt: state.editData.closeAt,
        commission: state.editData.commission,
        countryName: state.editData.countryName,
        currentStatus: state.editData.currentStatus,
        cutoffTime: state.editData.cutoffTime,
        dailyLimit: state.editData.dailyLimit,
        dailyRate: state.editData.dailyRate,
        description: state.editData.description,
        discount: state.editData.discount,
        hasADA: state.editData.hasADA,
        hasChargingStation: state.editData.hasChargingStation,
        hasSecurity: state.editData.hasSecurity,
        hasServicing: state.editData.hasServicing,
        hasValet: state.editData.hasValet,
        hasWash: state.editData.hasWash,
        hourlyLimit: state.editData.hourlyLimit,
        hourlyRate: state.editData.hourlyRate,
        id: state.editData.id,
        imageList: state.editData.imageList,
        latitude: state.editData.latitude,
        longitude: state.editData.longitude,
        name: state.editData.name,
        openAt: state.editData.openAt,
        parkingCategory: state.editData.parkingCategory,
        parkingRate: state.editData.parkingRate,
        parkingRefundType: state.editData.parkingRefundType,
        phoneNumber: state.editData.phoneNumber,
        postalcodeName: state.editData.postalcodeName,
        serviceProviderId: state.editData.serviceProviderId,
        stateId: state.editData.stateId,
        stateName: state.editData.stateName,
        status: state.editData.status,
        termAndCondition: state.editData.termAndCondition,
        tierType: state.editData.tierType,
        zipCode: state.editData.zipCode,
        vendorName: state.editData.serviceProviderDetailResponseDTO.name,
      });
    }
  }, []);

  const handleUpdateVendorCommission = (values, action) => {
    updateServiceProviderDetail({
      payload: {
        id: state.editData.id,
        userId: state.editData.userId,
        name: values.name,
        emailId: values.emailId,
        contactNumber: values.contactNumber,
        gstNo: values.gstNo,
        primaryAccountNo: values.primaryAccountNo,
        vatNo: values.vatNo,
        tierType: values.tierType,
        commission: values.commission,
        status: true,
      },
      token: token.token,
    });
  };

  const handleUpdateParkingCommission = (values, action) => {
    updateParkingSpaceLocation({
      token: token.token,
      payload: { ...values },
    });
  };

  return (
    <Page title="Add Commission">
      {state.isEditVendor ? (
        <Formik
          enableReinitialize={true}
          initialValues={initialValuesVendor}
          onSubmit={handleUpdateVendorCommission}
          validationSchema={VendorsSchema}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <Container
              sx={{
                paddingTop: '2rem',
                paddingBottom: '2rem',
              }}
            >
              <Typography variant="h3" marginBottom={'20px'} component="div">
                {state.isEditVendor ? "Update Vendor's Commission Details" : 'Update Parking space Commission Details'}
              </Typography>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width={'100%'} marginRight={'25px'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Username
                  </Typography>
                  <TextField
                    disabled
                    style={{ width: '100%' }}
                    name={'name'}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Box>
                <Box width="100%">
                  <Typography variant="h5" gutterBottom component="div">
                    Contact
                  </Typography>
                  <TextField
                    disabled
                    style={{ width: '100%' }}
                    placeholder="Enter Contact..."
                    name={'contactNumber'}
                    value={values.contactNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.contactNumber && errors.contactNumber)}
                    helperText={touched.contactNumber && errors.contactNumber}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width="100%" marginRight={'25px'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Select Tier Type
                  </Typography>
                  <Select
                    name="tierType"
                    id="tierType"
                    key={values.tierType}
                    value={values.tierType}
                    style={{
                      width: '100%',
                    }}
                    onChange={handleChange}
                    error={Boolean(touched.tierType && errors.tierType)}
                    displayEmpty
                    defaultValue={''}
                  >
                    <MenuItem disabled value="">
                      Select tier type
                    </MenuItem>
                    {tierType &&
                      tierType.map((tierTypes: any) => (
                        <MenuItem key={tierTypes.code} value={tierTypes.displayValue}>
                          {tierTypes.displayValue}
                        </MenuItem>
                      ))}
                  </Select>
                </Box>
                <Box width="100%">
                  <Typography variant="h5" gutterBottom component="div">
                    Enter Commission (%)
                  </Typography>
                  <TextField
                    placeholder="commission..."
                    name={'commission'}
                    style={{ width: '100%' }}
                    value={values.commission}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.commission && errors.commission)}
                    helperText={touched.commission && errors.commission}
                  />
                </Box>
              </Box>

              <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    navigate('/dashboard/commission-management');
                  }}
                  sx={{ marginRight: '10px' }}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleSubmit();
                  }}
                  size="large"
                  type="submit"
                >
                  Update
                </Button>
              </div>
            </Container>
          )}
        </Formik>
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={initialValuesParking}
          onSubmit={handleUpdateParkingCommission}
          validationSchema={ParkingsSchema}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
            <Container
              sx={{
                paddingTop: '2rem',
                paddingBottom: '2rem',
              }}
            >
              <Typography variant="h3" marginBottom={'20px'} component="div">
                {state.isEditVendor ? "Update Vendor's Commission Details" : 'Update Parking space Commission Details'}
              </Typography>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width={'100%'} marginRight={'25px'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Parking Space Name
                  </Typography>
                  <TextField
                    disabled
                    style={{ width: '100%' }}
                    name={'name'}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Box>
                <Box width="100%">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor Name
                  </Typography>
                  <TextField
                    disabled
                    style={{ width: '100%' }}
                    placeholder="Enter vendor name..."
                    name={'vendorName'}
                    id={'vendorName'}
                    value={values.vendorName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.vendorName && errors.vendorName)}
                    helperText={touched.vendorName && errors.vendorName}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width="100%" marginRight={'25px'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Select Tier Type
                  </Typography>
                  <Select
                    name="tierType"
                    id="tierType"
                    key={values.tierType}
                    value={values.tierType}
                    style={{
                      width: '100%',
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.tierType && errors.tierType)}
                  >
                    {tierType &&
                      tierType.map((tierTypes: any) => (
                        <MenuItem key={tierTypes.code} value={tierTypes.displayValue}>
                          {tierTypes.displayValue}
                        </MenuItem>
                      ))}
                  </Select>
                </Box>
                <Box width="100%">
                  <Typography variant="h5" gutterBottom component="div">
                    Enter Commission
                  </Typography>
                  <TextField
                    placeholder="commission..."
                    name={'commission'}
                    style={{ width: '100%' }}
                    value={values.commission}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.commission && errors.commission)}
                    helperText={touched.commission && errors.commission}
                  />
                </Box>
              </Box>

              <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    navigate('/dashboard/commission-management');
                  }}
                  sx={{ marginRight: '10px' }}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleSubmit();
                  }}
                  size="large"
                  type="submit"
                >
                  Update
                </Button>
              </div>
            </Container>
          )}
        </Formik>
      )}
      {getAllResponse.isLoading ||
      updateResponse.isLoading ||
      getAllParkingSpaceLocationResponse.isLoading ||
      updateParkingSpaceLocationResponse.isLoading ? (
        <Loading />
      ) : null}
    </Page>
  );
}
